// Imresed implementation for Ky by Sindre Sorhus
// https://github.com/sindresorhus/ky/blob/master/index.js#L3
const getGlobal = property => {
  /* istanbul ignore next */
  if (typeof self !== "undefined" && self && property in self) {
    return self[property];
  }
  /* istanbul ignore next */


  if (typeof window !== "undefined" && window && property in window) {
    return window[property];
  }

  if (typeof global !== "undefined" && global && property in global) {
    return global[property];
  }
  /* istanbul ignore next */


  if (typeof globalThis !== "undefined" && globalThis) {
    return globalThis[property];
  }
};

const setGlobal = (property, value) => {
  /* istanbul ignore next */
  if (typeof self !== "undefined" && self && property in self) {
    self[property] = value;
    return self[property];
  }
  /* istanbul ignore next */


  if (typeof window !== "undefined" && window && property in window) {
    window[property] = value;
    return window[property];
  }

  if (typeof global !== "undefined" && global && property in global) {
    global[property] = value;
    return global[property];
  }
  /* istanbul ignore next */


  if (typeof globalThis !== "undefined" && globalThis) {
    globalThis[property] = value;
    return globalThis[property];
  }
};

export { getGlobal, setGlobal };